export { default as WishlistMenuItem } from './components/WishlistMenuItemContainer.js';
//# sourceMappingURL=menu-item.js.map
